// extracted by mini-css-extract-plugin
module.exports = {"Container":"empty-state_Container__So8BB","narrow":"empty-state_narrow__TQEk_","wide":"empty-state_wide__VBHFk"};